import { StrictMode, useState, useCallback } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import { LoginScreen } from './components/LoginScreen'
import './index.css'

function AuthWrapper() {
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [_sessionToken, setSessionToken] = useState<string | null>(null)

  const handleLogin = useCallback((token: string) => {
    setSessionToken(token)
    setIsAuthenticated(true)
  }, [])

  if (!isAuthenticated) {
    return <LoginScreen onLogin={handleLogin} />
  }

  return <App />
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthWrapper />
  </StrictMode>
)
